import React, { Component, PropTypes } from 'react';
import AppPage from 'components/AppPage';
import CourseActions from 'actions/Course';
import AppActions from 'actions/App';
import AuthActions from 'actions/Auth';
import { ThemeStore, AuthStore, CourseStore } from 'stores';
import TableOfContentsContainer from 'components/Course/TableOfContentsContainer';
import { Paper, Styles } from 'material-ui';
import * as Icons from 'components/Material/SvgIcons';
import * as Colors from 'components/Material/Styles/Colors';
import SlidingPanel from 'components/SlidingPanel';
import CSSPropertyOperations from 'react/lib/CSSPropertyOperations';
import ToolbarIconButton from 'components/Material/ToolbarIconButton';
import { mixin, RefluxMixin } from 'Util';
import Loader from 'components/Material/Loader';
import { DragDropContext } from 'react-dnd';
import HTML5Backend from 'react-dnd-html5-backend';

let { Spacing } = Styles;

const styles = {
  toolbar: {
    color: Colors.Colors.fullWhite
  },
  toc: {
    position: 'fixed',
    left: 0,
    top: 0,
    bottom: 0,
    width: Spacing.desktopKeylineIncrement * 6,
    transition: 'all 0.5s ease',
    zIndex: 2
  }
};

const css = oxygenCss({
  section: {
    // backgroundColor: 'white',
    color: 'black',
    margin: 'auto',
    display: 'inline',
    padding: '0px 32px',
    lineHeight: '60px'
  }
});

class Course extends mixin(RefluxMixin, Component) {
  static contextTypes = {
    muiTheme: PropTypes.object,
    media: PropTypes.string,
    getIntlMessage: PropTypes.func
  };

  state = {
    sectionChange: false
  };

  listenToStores() {
    this.listenToStore(CourseStore);
    this.listenToStore(AuthStore, 'auth');
  }

  onMenuChange(e, key, payload) {}

  _gotoPage(sectionPage) {
    let { course } = this.state;
    let { page, chapter } = sectionPage;
    this.props.router.push(
      `/course/${course.ownerSlug}/${course.slug}/${chapter.slug}/${
        page.slug
      }/${page.id}`
    );
  }

  getTocStyle(tocEnabled) {
    let style = styles.toc;
    if (!tocEnabled) {
      style.left = -Spacing.desktopKeylineIncrement * 7;
    } else {
      style.left = 0;
    }
    return style;
  }

  componentDidMount() {
    if (this.state.tocEnabled) {
      this.slideAppRight();
    }
    const { course } = this.props;
    const { pageId, courseSlug, ownerSlug } = this.props.params;
    const { lastViewedPageId } = course;
    let lastViewedPageExists = false;
    if (!pageId) {
      course.toc.some(section => {
        const foundPage = section.pages.find(
          page => page.id === lastViewedPageId
        );
        lastViewedPageExists = !!foundPage;
        return lastViewedPageExists;
      });
      if (lastViewedPageId && lastViewedPageExists) {
        return this.props.router.replace(
          `/course/${ownerSlug}/${courseSlug}/${lastViewedPageId}`
        );
      }
      const firstPageId =
        course.toc &&
        course.toc[0] &&
        course.toc[0].pages &&
        course.toc[0].pages[0] &&
        course.toc[0].pages[0].id;
      if (firstPageId) {
        CourseActions.markPageViewed(course.id, firstPageId);
        this.props.router.replace(`/course/${ownerSlug}/${courseSlug}/${firstPageId}`);
      }
    }
  }

  componentWillUnmount() {
    if (super.componentWillUnmount) {
      super.componentWillUnmount();
    }
    if (this._timer) {
      clearTimeout(this._timer);
      this._timer = null;
    }

    let app = document.getElementById('root');
    CSSPropertyOperations.setValueForStyles(app, { left: 0 });
  }

  slideAppRight() {
    if (this.context.media !== 'phone') {
      let panelWidth = this.context.media === 'phone' ? 4 : 6;
      let app = document.getElementById('root');
      app.style.left = `${ Spacing.desktopKeylineIncrement * panelWidth }px` ;
    }
  }

  slideAppLeft() {
    let app = document.getElementById('root');
    app.style.left = 0;
    // CSSPropertyOperations.setValueForStyles(app, { left: 0 });
  }

  toggleLayoutDesign() {
    CourseActions.toggleLayoutDesign();
  }

  closeToc = () => {
    CourseActions.closeToc();
    this.slideAppLeft();
  };

  toggleToc = () => {
    CourseActions.toggleToc();
  };

  openToc = () => {
    CourseActions.openToc();
    this.slideAppRight();
  };

  createToc(panelWidth, pageId, courseSlug, ownerSlug) {
    let activePageId;
    if (this.state.page) {
      activePageId = this.state.page.id;
    }
    return (
      <SlidingPanel
        backgroundColor={Colors.Colors.fullWhite}
        width={panelWidth}
        overlay={this.context.media === 'phone'}
        initialOpen={this.state.tocEnabled}
        zIndex={1}
        ref="toc"
        onOpen={this.openToc}
        onClose={this.closeToc}
        onRequestClose={this.closeToc}
      >
        <TableOfContentsContainer
          reader={this.state.auth.role.reader}
          editor={this.state.auth.role.editor}
          auth={this.state.auth}
          currentPage={activePageId}
          courseSlug={courseSlug}
          ownerSlug={ownerSlug}
        />
      </SlidingPanel>
    );
  }

  builderMode() {
    AuthActions.builderMode();
  }

  readerMode() {
    AuthActions.readerMode();
  }

  componentWillReceiveProps(nextProps, nextState) {
    const { media } = this.context;
    const oldParams = this.props.params;
    const newParams = nextProps.params;
    const { pageId } = oldParams;
    const { pageId: nextPageId } = newParams;

    if (pageId !== nextPageId && media === 'phone') {
      this.closeToc();
    }

    if (oldParams.sectionSlug !== newParams.sectionSlug) {
      this.setState({ sectionChange: true });
      this._timer = setTimeout(() => {
        this.setState({ sectionChange: false });
      }, 2000);
    }
  }

  renderSectionChange(currentSection, backgroundColor) {
    const { media } = this.context;
    const style = {
      left: '50%',
      marginLeft: -5 * Spacing.desktopKeylineIncrement,
      position: 'absolute',
      width: Spacing.desktopKeylineIncrement * 10,
      textAlign: 'center',
      transition: 'all 0.5s ease',
      fontSize: '20px',
      letterSpacing: '0.5px',
      lineHeight: '64px',
      height: 60,
      color: '#393939',
      zIndex: 10,
      padding: 0,
      opacity: 1
    };
    if (this.state.sectionChange) {
      style.top = Spacing.desktopKeylineIncrement;
      style.backgroundColor = backgroundColor;
      style.color = Colors.Colors.fullWhite;
      if (media === 'phone') {
        style.left = Spacing.desktopGutterMini;
        style.right = Spacing.desktopGutterMini;
        style.marginLeft = 'auto';
        style.width = null;
      }
    } else {
      style.top = 0;
      style.backgroundColor = 'transparent';
      style.boxShadow = 'none';
      if (media === 'phone') {
        style.opacity = 0;
        style.left = 64;
        style.right = Spacing.desktopGutterMini;
        style.marginLeft = 'auto';
        style.width = null;
      }
    }
    return (
      <Paper style={style}>
        <div className={css.section}>{currentSection.name}</div>
      </Paper>
    );
  }

  render() {
    if (!this.state.course || !this.state.course.theme || !this.state.page) {
      return (
        <AppPage style={{ paddingTop: 0 }} key={pageId}>
          <Loader />
        </AppPage>
      );
    }

    const { pageId, courseSlug, ownerSlug } = this.props.params;
    let course = this.props.course;
    let panelWidth = this.context.media === 'phone' ? 4 : 6;
    let toc = this.createToc(
      panelWidth,
      course.lastViewedPageId,
      courseSlug,
      ownerSlug
    );

    const currentSection = course.toc.find(section => {
      const foundPage = section.pages.find(page => {
        return page.id === parseInt(pageId, 10);
      });
      return !!foundPage;
    });
    const sectionChange =
      currentSection &&
      this.renderSectionChange(
        currentSection,
        ThemeStore.getColor(course && course.theme.color, 0.8)
      );

    return (
      <AppPage style={{ paddingTop: 0 }}>
        {toc}
        {this.props.children}
        {sectionChange}
      </AppPage>
    );
  }
}

export default DragDropContext(HTML5Backend)(Course);



// WEBPACK FOOTER //
// ./src/js/components/Route/Course.js